export const GET_LEADERBOARD_POINTS = "GET_LEADERBOARD_POINTS"
export const GET_LEADERBOARD_POINTS_SUCCESS = "GET_LEADERBOARD_POINTS_SUCCESS"
export const GET_LEADERBOARD_POINTS_FAILED = "GET_LEADERBOARD_POINTS_FAILED"

export const UPDATE_LEADERBOARD_POINTS = "UPDATE_LEADERBOARD_POINTS"
export const UPDATE_LEADERBOARD_POINTS_SUCCESS =
  "UPDATE_LEADERBOARD_POINTS_SUCCESS"
export const UPDATE_LEADERBOARD_POINTS_FAILED =
  "UPDATE_LEADERBOARD_POINTS_FAILED"

export const SHOW_RESET_LEADERBOARD_MODAL = "SHOW_RESET_LEADERBOARD_MODAL"
export const HIDE_RESET_LEADERBOARD_MODAL = "HIDE_RESET_LEADERBOARD_MODAL"

export const CLEAR_LEADERBOARD = "CLEAR_LEADERBOARD"
export const CLEAR_LEADERBOARD_SUCCESS = "CLEAR_LEADERBOARD_SUCCESS"
export const CLEAR_LEADERBOARD_FAILED = "CLEAR_LEADERBOARD_FAILED"

export const GET_LEADERBOARD_USERS_POINTS = "GET_LEADERBOARD_USERS_POINTS"
export const GET_LEADERBOARD_USERS_POINTS_SUCCESS =
  "GET_LEADERBOARD_USERS_POINTS_SUCCESS"
export const GET_LEADERBOARD_USERS_POINTS_FAILED =
  "GET_LEADERBOARD_USERS_POINTS_FAILED"

export const GET_LEADERBOARD_USERS_LIST = "GET_LEADERBOARD_USERS_LIST"
export const GET_LEADERBOARD_USERS_LIST_SUCCESS =
  "GET_LEADERBOARD_USERS_LIST_SUCCESS"
export const GET_LEADERBOARD_USERS_LIST_FAILED =
  "GET_LEADERBOARD_USERS_LIST_FAILED"

export const RESET_LEADERBOARD_FORM = "RESET_LEADERBOARD_FORM"
